export default __webpack_public_path__ + "static/media/greengram.cad68cd9.png";